<template>
  <v-container>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">ปิดปรับปรุงระบบชั่วคราว</span>
      </div>
    </template>
    <template v-else>
      <v-card style="border: black 2px solid">
        <v-card-title class="headline mb-1">
          <span> ข้อมูลเสนอแผนโครงการ</span>
        </v-card-title>
        <v-container>
          <v-list>
            <v-list-item>
              <v-row class="d-flex justify-center">
                <v-col
                    cols="12"
                    md="12"
                >
                  <v-radio-group row v-model="YearSel" @change="ChooseYearFiscal">
                    <v-radio label="แผนประจำปี 2564" value="2021"></v-radio>
                    <v-radio label="แผนประจำปี 2565" value="2022"></v-radio>
                    <v-radio label="แผนประจำปี 2566" value="2023"></v-radio>
                    <v-radio label="แผนประจำปี 2567" value="2024"></v-radio>
                    <v-radio label="แผนประจำปี 2568" value="2025"></v-radio>
                    <v-radio label="แผนประจำปี 2569" value="2026"></v-radio>
                    <v-radio label="แผนประจำปี 2570" value="2027"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
          <v-expand-transition>
            <v-card v-if="!Details_Cordi"
                    style="border: black 1px solid"
            >
              <v-row
                  justify="center"
                  class="d-flex justify-center">
                <v-col
                    cols="12"
                    md="12">
                  <v-card-title>
                    ตารางข้อมูลรายละเอียดเสนอแผนโครงการ
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="ค้นหา รหัสโครงการ, โครงการ"
                        single-line
                        hide-details
                    ></v-text-field>
                  </v-card-title>
                </v-col>
              </v-row>
              <v-row
                  justify="center"
                  class="justify-center">
                <v-col
                    cols="12"
                    md="12"
                >

                  <!--                        @click:row="GetData"-->
                  <v-data-table
                      :headers="courseHeaders"
                      :items="projectDataToTable"
                      :search="search"
                      item-key="Project_code"
                      :single-expand="singleExpand"
                      :expanded.sync="expanded"
                      class="elevation-1"
                  >
                    <template v-slot:header.Project_code>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        รหัสโครงการ
                      </v-label>
                    </template>
                    <template v-slot:header.full_Name>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        โครงการ
                      </v-label>
                    </template>
                    <template v-slot:header.IsPlanStatus>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        สถานะ
                      </v-label>
                    </template>
                    <template v-slot:header.Item_Code>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        item code
                      </v-label>
                    </template>
                    <template v-slot:header.BudgetRequest>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        งบประมาณ
                      </v-label>
                    </template>
                    <template v-slot:item.full_Name="{item}">
                      <div v-html="item.full_Name"></div>
                    </template>
                    <template v-slot:item.IsPlanStatus="{item}">
                      <v-btn
                          v-if="item.IsPlanStatus == '0'"
                          outlined
                          color="#00C853"
                          style="transform: scale(0.8);"
                          @click="Project_proposal(item)"
                      >
                        เสนอแผนโครงการ
                      </v-btn>

                      <v-chip
                          color="#6D4C41"
                          style="transform: scale(0.8);color: white"
                          v-else-if="item.IsPlanStatus == '1'"
                      >
                        <span style="color: white">รอพิจารณา</span>
                      </v-chip>

                      <v-chip
                          color="#00BFA5"
                          style="transform: scale(0.8);color: white"
                          v-else-if="item.IsPlanStatus == '2'"
                      >
                        อนุมติ
                      </v-chip>
                      <v-chip
                          color="#F50057"
                          style="transform: scale(0.8);color: white"
                          v-else-if="item.IsPlanStatus == '3'"
                      >
                        ไม่อนุมัติ
                      </v-chip>
                      <v-chip
                          color="#C0CA33"
                          style="transform: scale(0.8);color: white"
                          v-else-if="item.IsPlanStatus == '4'"
                      >
                        แก้ไข
                      </v-chip>
                      <v-chip
                          color="primary"
                          style="transform: scale(0.8);color: white"
                          v-else
                      >
                        ยกเลิกโครงการ
                      </v-chip>
                    </template>
                    <template v-slot:item.Item_Code="props">
                      <v-edit-dialog
                          :return-value.sync="props.item.Item_Code"
                          large
                          persistent
                          @save="save(props.item)"
                          @cancel="cancel"
                          @open="open"
                          @close="close"
                      >
                        {{ props.item.Item_Code }}
                        <template v-slot:input>
                          <v-text-field
                              v-model="props.item.Item_Code"
                              label=""
                              single-line
                              counter
                              autofocus
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </template>
                    <template v-slot:item.Project_Details="{ item }">
                      <v-btn
                          text
                          color="#FFB300"
                          @click="ShowDetail(item)"
                      >
                        รายละเอียด
                      </v-btn>
                    </template>
                    <template
                        v-slot:footer
                    >
                      <div align="center" class="mt-6">
                        <span style="font-weight: bold;color: #364eff"> รวมงบประมาณประจำปี {{parseInt(YearSel) + 543}} : {{allMoney}}  บาท</span>
                      </div>
                    </template>
                    <!--                <template v-slot:footer="{item, header}">
                                      <tr>
                                        <td :colspan="header.length">

                                        </td>
                                      </tr>
                                    </template>-->
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card>
          </v-expand-transition>

          <v-card v-if="Details_Cordi"
                  elevation="10"
          >
            <v-list-item>
              <v-btn
                  outlined
                  color="#FF5722"
                  @click="BackMenu">
                ย้อนกลับ
              </v-btn>
            </v-list-item>
            <v-card-text>
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1"><span>ข้อมูลเสนอแผนโครงการ</span>
                  </v-list-item-title>
                  <v-list-item>
                    <v-row justify="space-around">
                      <p>วันที่เริ่มต้นโครงการ</p>
                      <p>วันที่สิ้นสุดโครงการ</p>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row justify="space-around">

                      <v-date-picker
                          style="border: black 1px solid"
                          v-model="DateStart"
                          :landscape="landscape"
                          :reactive="reactive"
                          :full-width="fullWidth"
                          :show-current="showCurrent"
                          :type="month ? 'month' : 'date'"
                          :multiple="multiple"
                          :readonly="readonly"
                          :disabled="disabled"
                          locale="th"
                          :events="enableEvents ? functionEvents : null"
                      ></v-date-picker>

                      <v-date-picker
                          style="border: black 1px solid"
                          v-model="DateEnd"
                          :landscape="landscape"
                          :reactive="reactive"
                          :full-width="fullWidth"
                          :show-current="showCurrent"
                          :type="month ? 'month' : 'date'"
                          :multiple="multiple"
                          :readonly="readonly"
                          :disabled="disabled"
                          locale="th"
                          :events="enableEvents ? functionEvents : null"
                      ></v-date-picker>
                    </v-row>
                  </v-list-item>
                  <v-list-item style="margin-top: 20px">
                    <v-row class="d-flex justify-center">
                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-autocomplete
                            v-model="DepSelect"
                            label="หน่วยงาน"
                            :items="depart"
                            item-text="dep_name"
                            item-value="dep_id"
                            disabled
                        >

                        </v-autocomplete>
                      </v-col>
                      <v-col
                          cols="12"
                          md="4"
                      >
                        <v-autocomplete
                            v-model="FiscalYear"
                            label="โครการของปี"
                            :items="FiscalYearData"
                            item-text="yearth"
                            item-value="year"
                            readonly
                        ></v-autocomplete>
                      </v-col>
                      <v-col
                          cols="12"
                          md="2"
                      >
                        <v-text-field label="ITEM CODE" v-model="itemCode"></v-text-field>
                        <div>
                          <v-btn text @click="save(Project)" color="primary">บันทึก</v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row>
                      <v-col
                          cols="4"
                      >
                        <div class="d-inline">
                          <v-text-field v-model="Project_code" label="รหัสโครงการ"
                                        :rules="[rules.required]"
                                        hide-details="auto"
                                        disabled></v-text-field>
                        </div>
                      </v-col>
                      <v-col
                          cols="5"
                      >
                        <div class="d-inline">
                          <v-text-field v-model="Project_name" label="ชื่อโครงการ"
                                        :rules="[rules.required]"
                                        hide-details="auto"
                                        disabled></v-text-field>
                        </div>
                      </v-col>
                      <v-col
                          cols="3"
                      >
                        <div class="d-inline">
                          <v-autocomplete
                              v-model="Project_group"
                              :items="projectGroup"
                              item-value="Project_group"
                              item-text="Project_group_des"
                              label="ประเภทโครงการ"
                              readonly
                          ></v-autocomplete>
                        </div>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item v-if="Course_code != null">
                    <v-row>
                      <v-col
                          cols="12"
                          md="4"
                      >
                        <div class="d-inline">
                          <v-autocomplete
                              :items="courseData"
                              item-text="Course_name"
                              item-value="Course_code"
                              :rules="[rules.required]"
                              v-model="Course_code"
                              label="หลักสูตร"
                              disabled
                          ></v-autocomplete>
                        </div>
                      </v-col>
                      <v-col
                          cols="12"
                          md="2"
                      >
                        <div class="d-inline">
                          <v-text-field
                              v-model="course_group"
                              label="สาขาประเภทหลักสูตร"
                              required
                              disabled
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col
                          cols="6"
                          md="2"
                      >
                        <div class="d-inline">
                          <v-autocomplete
                              disabled
                              :items="period"
                              item-text="name"
                              item-value="id"
                              v-model="Period_code"
                              label="ระยะเวลา"
                              :rules="[rules.required]"
                          ></v-autocomplete>
                        </div>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <!--                                                        <v-list-item class="d-flex flex-row justify-center align-center"-->
                  <!--                                                                     v-if="projectNeed">-->
                  <!--                                                            <v-list-item>-->
                  <!--                                                                <v-row>-->
                  <!--                                                                    <v-col-->
                  <!--                                                                            cols="12"-->
                  <!--                                                                            md="6">-->
                  <!--                                                                        <v-row-->
                  <!--                                                                                justify="center">-->
                  <!--                                                                            <v-col-->
                  <!--                                                                                    class="d-flex justify-center"-->
                  <!--                                                                                    cols="12"-->
                  <!--                                                                                    md="8">-->
                  <!--                                                                                <v-data-table-->
                  <!--                                                                                        :headers="courseHeadersCondi"-->
                  <!--                                                                                        :items="courseCondi"-->
                  <!--                                                                                        :search="search"-->
                  <!--                                                                                        item-key="Course_code"-->
                  <!--                                                                                        class="elevation-1"-->
                  <!--                                                                                >-->
                  <!--                                                                                    <template v-slot:header.Course_code>-->
                  <!--                                                                                        <v-label-->
                  <!--                                                                                                fontSize="16px"-->
                  <!--                                                                                                fontWeight="bold">-->
                  <!--                                                                                            รหัสหลักสูตร-->
                  <!--                                                                                        </v-label>-->
                  <!--                                                                                    </template>-->
                  <!--                                                                                    <template v-slot:header.Course_name>-->
                  <!--                                                                                        <v-label-->
                  <!--                                                                                                fontSize="16px"-->
                  <!--                                                                                                fontWeight="bold">-->
                  <!--                                                                                            หลักสูตรที่ต้องผ่าน-->
                  <!--                                                                                        </v-label>-->
                  <!--                                                                                    </template>-->
                  <!--                                                                                    <template v-slot:item.action="{ item }">-->
                  <!--                                                                                        <v-row class="d-flex">-->
                  <!--                                                                                            <v-col-->
                  <!--                                                                                                    cols="6"-->
                  <!--                                                                                                    md="6">-->
                  <!--                                                                                                <v-btn-->
                  <!--                                                                                                        outlined-->
                  <!--                                                                                                        color="#BF360C"-->
                  <!--                                                                                                        @click="DeleteCourse(item)">-->
                  <!--                                                                                                    ลบ-->
                  <!--                                                                                                </v-btn>-->
                  <!--                                                                                            </v-col>-->
                  <!--                                                                                        </v-row>-->
                  <!--                                                                                    </template>-->
                  <!--                                                                                </v-data-table>-->
                  <!--                                                                            </v-col>-->
                  <!--                                                                        </v-row>-->
                  <!--                                                                    </v-col>-->
                  <!--                                                                    <v-col-->
                  <!--                                                                            cols="12"-->
                  <!--                                                                            md="6">-->
                  <!--                                                                        <v-row>-->
                  <!--                                                                            <v-row-->
                  <!--                                                                                    justify="center"-->
                  <!--                                                                                    class="d-flex justify-center">-->
                  <!--                                                                                <v-col-->
                  <!--                                                                                        cols="12"-->
                  <!--                                                                                        md="12">-->
                  <!--                                                                                    <v-data-table-->
                  <!--                                                                                            :headers="dataHeadersCondi"-->
                  <!--                                                                                            :items="DataCondi"-->
                  <!--                                                                                            :search="search"-->
                  <!--                                                                                            item-key="PosWork"-->
                  <!--                                                                                            class="elevation-1"-->
                  <!--                                                                                    >-->
                  <!--                                                                                        <template v-slot:header.PosName>-->
                  <!--                                                                                            <v-label-->
                  <!--                                                                                                    fontSize="16px"-->
                  <!--                                                                                                    fontWeight="bold">-->
                  <!--                                                                                                เงื่อนไขตำแหน่ง, อายุงาน-->
                  <!--                                                                                            </v-label>-->
                  <!--                                                                                        </template>-->
                  <!--                                                                                        <template v-slot:header.Level>-->
                  <!--                                                                                            <v-label-->
                  <!--                                                                                                    fontSize="16px"-->
                  <!--                                                                                                    fontWeight="bold">-->
                  <!--                                                                                                ระดับ-->
                  <!--                                                                                            </v-label>-->
                  <!--                                                                                        </template>-->
                  <!--                                                                                        <template v-slot:header.workAgeStart>-->
                  <!--                                                                                            <v-label-->
                  <!--                                                                                                    fontSize="16px"-->
                  <!--                                                                                                    fontWeight="bold">-->
                  <!--                                                                                                อายุงานเริ่มต้น-->
                  <!--                                                                                            </v-label>-->
                  <!--                                                                                        </template>-->
                  <!--                                                                                        <template v-slot:header.workAgeEnd>-->
                  <!--                                                                                            <v-label-->
                  <!--                                                                                                    fontSize="16px"-->
                  <!--                                                                                                    fontWeight="bold">-->
                  <!--                                                                                                อายุงานสิ้นสุด-->
                  <!--                                                                                            </v-label>-->
                  <!--                                                                                        </template>-->
                  <!--                                                                                        <template v-slot:item.PosName="{ item }">-->
                  <!--                                                                                            <v-label>-->
                  <!--                                                                                                {{item.PosName}}-->
                  <!--                                                                                            </v-label>-->
                  <!--                                                                                        </template>-->
                  <!--                                                                                        <template v-slot:item.Level="{ item }">-->
                  <!--                                                                                            <v-label>-->
                  <!--                                                                                                {{item.Level}}-->
                  <!--                                                                                            </v-label>-->
                  <!--                                                                                        </template>-->
                  <!--                                                                                        <template-->
                  <!--                                                                                                v-slot:item.workAgeStart="{ item }">-->
                  <!--                                                                                            <v-label>-->
                  <!--                                                                                                {{item.workAgeStart}} (ปี)-->
                  <!--                                                                                            </v-label>-->
                  <!--                                                                                        </template>-->
                  <!--                                                                                        <template v-slot:item.workAgeEnd="{ item }">-->
                  <!--                                                                                            <v-label>-->
                  <!--                                                                                                {{item.workAgeEnd}} (ปี)-->
                  <!--                                                                                            </v-label>-->
                  <!--                                                                                        </template>-->
                  <!--                                                                                        <template v-slot:item.action="{ item }">-->
                  <!--                                                                                            <v-row class="d-flex">-->
                  <!--                                                                                                <v-col-->
                  <!--                                                                                                        cols="6"-->
                  <!--                                                                                                        md="6">-->
                  <!--                                                                                                    <v-btn-->
                  <!--                                                                                                            outlined-->
                  <!--                                                                                                            color="#BF360C"-->
                  <!--                                                                                                            @click="DeleteDataCondi(item)">-->
                  <!--                                                                                                        ลบ-->
                  <!--                                                                                                    </v-btn>-->
                  <!--                                                                                                </v-col>-->
                  <!--                                                                                            </v-row>-->
                  <!--                                                                                        </template>-->
                  <!--                                                                                    </v-data-table>-->
                  <!--                                                                                </v-col>-->
                  <!--                                                                            </v-row>-->
                  <!--                                                                        </v-row>-->
                  <!--                                                                    </v-col>-->
                  <!--                                                                </v-row>-->
                  <!--                                                            </v-list-item>-->
                  <!--                                                        </v-list-item>-->
                  <div v-else align="center" style="padding: 30px">
                                  <span style="text-align: center;font-weight: bold;color: #ff6d81;">
                                    ไม่พบข้อมูลหลักสูตร
                                  </span>
                  </div>
                  <v-list-item>
                    <v-row>
                      <v-col
                          cols="6"
                          md="3"
                      >
                        <div class="d-inline">
                          <v-text-field v-model="CalHourse" label="จำนวน ช.ม"
                                        hide-details="auto"
                                        :rules="[rules.required]"
                                        disabled></v-text-field>
                        </div>
                      </v-col>
                      <v-col
                          cols="6"
                          md="3"
                      >
                        <div class="d-inline">
                          <v-text-field v-model="CalCredit" label="จำนวน เครดิต"
                                        hide-details="auto"
                                        :rules="[rules.required]"
                                        disabled></v-text-field>
                        </div>
                      </v-col>
                      <v-col
                          cols="6"
                          md="3"
                      >
                        <div class="d-inline">
                          <v-autocomplete
                              :items="PLACESelete"
                              item-value="id"
                              item-text="detail"
                              v-model="PLACE"
                              label="โครงการถูกจัดขึ้น"
                              readonly
                          >
                          </v-autocomplete>
                        </div>
                      </v-col>
                      <v-col
                          cols="6"
                          md="3"
                      >
                        <div class="d-inline" v-if="PLACE == '2'">
                          <v-autocomplete
                              v-model="Province_id"
                              :items="provinces_Data"
                              item-text="name_th"
                              item-value="code"
                              label="จังหวัด"
                              readonly
                          ></v-autocomplete>
                        </div>
                        <div class="d-inline" v-if="PLACE == '3'">
                          <v-autocomplete
                              v-model="Country_id"
                              :items="countryData"
                              item-text="ct_nameTHA"
                              item-value="ct_code"
                              label="ประเทศ"
                              readonly
                          ></v-autocomplete>
                        </div>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row>
                      <v-col
                          cols="6"
                          md="3"
                      >
                        <div class="d-inline">
                          <v-text-field v-model="BudgetRequest" label="งบประมาณที่ขอ"
                                        hide-details="auto"
                                        :rules="[rules.required]"
                                        disabled></v-text-field>
                        </div>
                      </v-col>
                      <v-col
                          cols="6"
                          md="3"
                      >
                        <div class="d-inline">
                          <v-autocomplete
                              v-model="WorkBy"
                              label="จัดโดย"
                              :items="WorkByData"
                              item-value="id"
                              item-text="detail"
                              readonly></v-autocomplete>
                        </div>
                      </v-col>
                      <v-col
                          cols="6"
                          md="3"
                      >
                        <div class="d-inline">
                          <v-text-field
                              v-model="WorkByName"
                              label="ชื่อผู้จัด"
                              hide-details="auto"
                              readonly
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col
                          cols="6"
                          md="3"
                      >
                        <div class="d-inline">
                          <v-text-field
                              v-model="Location"
                              label="สถานที่จัดโครงการ"
                              hide-details="auto"
                              :rules="[rules.required]"
                              readonly></v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row>
                      <v-col
                          cols="12"
                      >
                        <div class="d-inline">
                          <v-textarea
                              v-model="Remarks"
                              outlined
                              name=""
                              label="รายละเอียดประกอบโครงการ"
                              value=""
                              readonly
                          ></v-textarea>
                        </div>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item v-if="FileProject.length > 0">
                    <template>
                      <v-row>
                        <v-col cols="12" sm="6" offset-sm="3">
                          <v-card>
                            <v-card-title>
                              ไฟล์เอกสารประกอบ
                            </v-card-title>
                            <v-container fluid>
                              <v-row>
                                <v-col
                                    v-for="(file_i, index) in FileProject"
                                    :key="index"
                                    class="d-flex child-flex"
                                    cols="12"
                                    md="4"
                                >
                                  <v-card flat tile>
                                    <v-img
                                        v-if="file_i.type == 'image'"
                                        :src="file_i.src"
                                        :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                        aspect-ratio="1"
                                        class="grey lighten-2"
                                    >
                                      <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                          <v-progress-circular
                                              indeterminate
                                              color="grey lighten-5"></v-progress-circular>
                                        </v-row>
                                      </template>
                                    </v-img>
                                    <v-img
                                        v-if="file_i.type == 'pdf'"
                                        src="../assets/Image/pdf.png"
                                        :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                        aspect-ratio="1"
                                        class="grey lighten-2"
                                    >
                                      <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                          <v-progress-circular
                                              indeterminate
                                              color="grey lighten-5"></v-progress-circular>
                                        </v-row>
                                      </template>
                                    </v-img>
                                    <v-card-text>
                                                                                                  <span
                                                                                                      style="font-weight: bold;color: black">
                                                                                                      {{ file_i.name }}
                                                                                                  </span>
                                    </v-card-text>
                                    <v-card-actions>
                                      <v-btn text @click="ShowData(file_i.src)">
                                                                                                      <span
                                                                                                          style="color: indigo;font-weight: bold">
                                                                                                          เรียกดู
                                                                                                      </span>
                                      </v-btn>
                                    </v-card-actions>
                                  </v-card>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card>
                        </v-col>
                      </v-row>
                    </template>
                  </v-list-item>
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-container>
      </v-card>
      <template>
        <v-dialog v-model="dialogProposal" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">ยืนยันการทำรายการ</v-card-title>
            <v-card-text>ต้องการยื่นเสนอโครงการใช่หรือไม่ ?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="dialogProposal = false">ยกเลิก</v-btn>
              <v-btn color="green darken-1" text @click="proposal_To_Db">ตกลง</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogDetail"
            max-width="800"
        >
          <v-card v-if="itemToShow != null">
            <v-card-title class="headline"><span style="color: #42b983;font-weight: bold">{{ itemToShow.DelvDes }}</span>
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col
                    cols="12"
                    md="12">
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">ชื่อย่อ:</span> {{ itemToShow.DelvShort }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">ชื่อ Eng:</span> {{ itemToShow.DelvEng }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">คำอธิบาย:</span> {{ itemToShow.DelvRm }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">PSU:</span> {{ itemToShow.PSU }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black" v-if="itemToShow.DelvGroup == 'A'">
                    <span style="color: #364eff">กรุ๊ป:</span> สมรรถนะหลัก
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'B'">
                    <span style="color: #364eff">กรุ๊ป:</span> สมรรถนะด้านบริหาร
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'C'">
                    <span style="color: #364eff">กรุ๊ป:</span> จิตสํานึกด้านความเสียงและความปลอดภัย
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'D'">
                    <span style="color: #364eff">กรุ๊ป:</span> กลยุทธ์
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">คณะ/หน่วยงาน:</span> {{ itemToShow.dep_name }}
                  </p>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="green darken-1"
                  text
                  @click="dialogDetail = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogTemplate"
            max-width="800"
        >
          <v-card>
            <v-card-title>ฟอร์ฺมตัวอย่าง</v-card-title>
            <v-card-text>
              <div v-html="editorData"></div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="green darken-1"
                  text
                  @click="dialogTemplate = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogLecturerDetail"
            max-width="800"
        >
          <v-card>
            <v-card-title class="headline"><span style="color: #42b983;font-weight: bold">รายละเอียดการเป็นวิทยากร/คณะกรรมการ/นำเสนอผลงาน</span>
            </v-card-title>
            <v-card-text>
              <v-data-table :items="LecturerDetail" :headers="headerLecturer" class="elevation-2"
                            show-expand
                            style="width: 100%">
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <div v-for="(file, idx) in item.files" v-bind:key="idx">
                      <v-btn color="primary" text @click="ShowData(Openfile + file.File_path)">ไฟล์ : {{ file.File_name }}
                      </v-btn>
                    </div>
                  </td>
                </template>
                <template v-slot:item.date_start="{item}">
                  <span>
                    {{ item.date_start | DateToThai }}
                  </span>
                </template>
                <template v-slot:item.date_end="{item}">
                  <span>
                    {{ item.date_end | DateToThai }}
                  </span>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red darken-1"
                  text
                  @click="dialogLecturerDetail = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <v-dialog
          v-model="dialogLoading"
          persistent
          width="300"
      >
        <v-card
            color="primary"
            dark
        >
          <v-card-text>
            Please stand by
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <template>
      <v-snackbar
          v-model="snack"
          :timeout="3000"
          :color="snackColor"
      >
        {{ snackText }}

        <template v-slot:action="{ attrs }">
          <v-btn
              v-bind="attrs"
              text
              @click="snack = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </template>
    </template>
  </v-container>
</template>

<script>
import axios from 'axios'
import ConstData from '../const/Const'
import {mapActions, mapGetters} from "vuex";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
// import Vue from "vue";

export default {


  name: "Item_Code",
  data() {
    return {
      maintain: false,
      allMoney: 0,
      dateApprove: '',
      Project: null,
      snack: false,
      snackColor: '',
      snackText: '',
      max25chars: v => v.length <= 25 || 'Input too long!',
      pagination: {},
      YearSel: '',
      IsPlan: '',
      PlanProject_code: '',
      Project_code_dump: '',
      itemCode: '',
      ProjectPlan: '',
      Project_plan: [],
      TypeCreateProject: '0',
      FiscalYearData: [],
      TypeProject: '0',
      projectDataToTable: [],
      projectDataToTableDump: [],
      allProjectDataToTable: [],
      rdoRegisterProject: '0',
      ProjectQuotaDepCount: 0,
      dateRegStart: '',
      dateRegEnd: '',
      MessageSuc: '',
      MessageError: '',
      ShowAlertErr: false,
      ShowAlertSuc: false,
      DepQuotaData: [],
      searchDepQuota: '',
      ChooseTypRegis: '1',
      ChooseTypRegis2: '0',
      ChkJoinPerson: true,
      ProjectQuotaCount: '',
      DepQuotaCount: '',
      groupDepart: [],
      ChooseTypeDep: '0',
      DepQuotaSelect: '',
      CheckAdmin: false,
      CheckSubAdmin: false,
      WorkGroupData: [],
      dialogLecturerDetail: false,
      LecturerDetail: [],
      Country_id: '',
      dialogLecturer: false,
      percent: 0,
      dialogTemplate: false,
      CheckLecturer: false,
      Lecturer: [],
      TemplateProject: [],
      LecturerToShow: [],
      Committee_ToShow: [],
      projectGroupToShow: [],
      headerLecturer: [
        {text: 'หัวข้อเรื่อง', value: 'subject'},
        {text: 'วันที่เริ่มต้น', value: 'date_start'},
        {text: 'วันที่สิ้นสุด', value: 'date_end'},
        {text: 'เวลาเริ่มต้น', value: 'time_start'},
        {text: 'เวลาสิ้นสุด', value: 'time_end'}
      ],
      DepQuotaHeader: [
        {text: 'ประเภท', value: 'type'},
        {text: 'ภาควิชา/หน่วยงาน', value: 'dep_name'},
        {text: 'จำนวน', value: 'count'},
        {text: '', value: 'action'},
      ],
      SubjectForLecturer: '',
      dateSForLecturer: '',
      dateEForLecturer: '',
      timeSForLecturer: '',
      timeEForLecturer: '',
      editor: DecoupledEditor,
      editorDataGenerate: '',
      editorDataFormDB: '',
      editorData: '',
      dialogLoading: false,
      Expense: 0,
      Openfile: ConstData.ConnectionHost + '/rest/files',
      CompetencyToShow: [],
      ReqMoney: '',
      Rm: '',
      selection: [],
      dialogDetail: false,
      itemToShow: null,
      searchCompe: '',
      isMobile: false,
      SelDelvNo: '',
      itemsSel: [],
      CompetencyData: [],
      proposal: [],
      dialogProposal: false,
      Period_code: '',
      period: [
        {
          'name': 'ระยะสั้น (ไม่เกิน 1 เดือน)',
          'id': '2'
        },
        {
          'name': 'ระยะยาว (มากกว่า 1 เดือน)',
          'id': '3'
        }
      ],
      RecordData: [],
      searchPerson: '',
      headersPerson: [
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'สังกัด', value: 'affiliation'},
        {text: 'ลงทะเบียน', value: 'status_reg'},
      ],
      JoinPerson: [],
      Approve_m: '',
      Approve_Status: [
        {
          id: 0,
          detail: 'อนุมัติ'
        },
        {
          id: 1,
          detail: 'ไม่อนุมัติ'
        },
        {
          id: 2,
          detail: 'แก้ไข'
        }
      ],
      FileProject: [],
      File_Consider: [],
      alert: false,
      txtAlert: [],
      tab: null,
      Competency_code: '',
      UPercent: '',
      competencyHeader: [
        {text: 'Competency', value: 'Competency_des'},
        {text: 'เปอเซ็นต์', value: 'UPercent'}
      ],
      competency_DataForSubmit: [],
      expenseCostSum: 0,
      DepCost: '',
      expenseCost: '',
      moneyCost: '',
      expense_DataForSubmit: [],
      expense_p_DataForSubmit: [],
      CheckStep1: true,
      e1: 1,
      steps: 8,
      vertical: true,
      altLabels: false,
      editable: true,
      Details_Cordi: false,
      CheckFiles: false,
      full_name: '',
      phone: '',
      perid: '',
      peridCommittee: '',
      Committee_code: '',
      radioGroup: '0',
      radioGroup2: '0',
      files: [],
      Project_Choose: '',
      ChooseCourse: '',
      posiCondi: '',
      levelCondi: '',
      WSYear_Condi: '',
      WEYear_Condi: '',
      Course_Choose: '',
      DataCondi: [],
      courseCondi: [],
      Project_code: '',
      Project_name: '',
      Course_code: '',
      FiscalYear: '',
      course_group: '',
      Project_type: '',
      WorkBy: '',
      WorkByName: '',
      Location: '',
      DateStart: '',
      DateEnd: '',
      CalHourse: '',
      CalCredit: '',
      PLACE: '',
      Province_id: '',
      Status: '',
      Remarks: '',
      remarksApprove: '',
      ProjectLevel: '',
      App_doc_no: '',
      BudgetRequest: '',
      BudgetArrove: '',
      Project_group: '',
      D_Project: {
        Project_code: '',
        Project_name: '',
        Course_code: '',
        course_group: '',
        Project_type: '',
        WorkBy: '',
        Location: '',
        DateStart: '',
        DateEnd: '',
        CalHourse: '',
        CalCredit: '',
        PLACE: '',
        Province_id: '',
        Status: '',
        Remarks: '',
        ProjectLevel: '',
        App_doc_no: '',
        BudgetRequest: '',
        BudgetArrove: '',
        Project_group: '',
        FiscalYear: '',
        IsPlan: '',
        IsPlanStatus: '',
        Status_Reg: '',
        Status_Type_Reg: '',
        DateS_Reg: '',
        DateE_Reg: '',
        Status_Count_Reg: '',
        Count_Reg: '',
        Dep_Code: '',
        Create_By: '',
        Create_Time: '',
        Update_By: '',
        Update_Time: '',
      },
      expanded: [],
      singleExpand: false,
      search: '',
      search2: '',
      CoordinatorHeader: [
        {text: 'ชื่อ - สกุล', value: 'Name'},
        {text: 'ตำแหน่ง', value: 'position_com'},
        {text: 'เบอรโ์โทร', value: 'TEL'},
        {text: 'สถานะ', value: 'Committee_type'},
        {text: 'วิทยากร', value: 'Lecturer'},
      ],
      Coordinator: [],
      courseHeadersCondi: [
        {text: 'หลักสูตร', value: 'Course_name'}
      ],
      courseDataCondi: [],
      dataHeadersCondi: [
        {text: 'ตำแหน่ง', value: 'PosName'},
        {text: 'อายุงานเริ่มต้น', value: 'WSYear'},
        {text: 'อายุงานสิ้นสุด', value: 'WEYear'}
      ],
      dataDataCondi: [],
      projectNeed: false,
      picker: new Date().toISOString().substr(0, 10),
      landscape: false,
      reactive: false,
      fullWidth: false,
      showCurrent: true,
      month: false,
      multiple: false,
      readonly: false,
      disabled: false,
      enableEvents: false,
      PLACESelete: [
        {
          id: '0', detail: 'ภายในคณะ'
        },
        {
          id: '1', detail: 'ภายในมหาวิทยาลัย'
        },
        {
          id: '2', detail: 'ภายในจังหวัด'
        },
        {
          id: '3', detail: 'ต่างประเทศ'
        },
        {
          id: '4', detail: 'online'
        }
      ],
      WorkByData: [
        {
          id: 'D', detail: 'หน่วยงาน'
        },
        {
          id: 'F', detail: 'คณะ'
        },
        {
          id: 'U', detail: 'มหาวิทยาลัย'
        },
        {
          id: 'P', detail: 'ภายนอก'
        },
        {
          id: 'C', detail: 'ร่วมโครงการ'
        },
      ],
      Menu: [
        {
          'id': 1,
          'value': 'จัดโครงการ'
        },
        {
          'id': 2,
          'value': 'จัดการข้อมูลโครงการ'
        },
        {
          'id': 3,
          'value': 'ข้อมูลเบิกจ่ายเงินโครงการ'
        }],
      projectType: [
        {
          id: '0',
          details: 'อบรม'
        },
        {
          id: '1',
          details: 'ดูงาน'
        },
        {
          id: '2',
          details: 'ประชุม'
        },
        {
          id: '3',
          details: 'นำเสนองาน'
        }
      ],
      workBy: [
        'Depart',
        'Faculty',
        'University',
        'Public C',
        'Co-Project'
      ],
      CourseType: [
        'ทั่วไป',
        'เฉพาะตำแหน่ง'
      ],
      DataCourse: {
        Project_code: '',
        Course_code: '',
        Credit: ''
      },
      rules: {
        required: value => !!value || 'Required.',
        counterCourse: value => value.length <= 8 || 'Max 8 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
      allProjectHeader: [
        {
          text: 'รหัสหลักสูตร', class: 'HeaderTable',
          align: 'start',
          value: 'Project_code',
        },
        {text: 'หลักสูตร', value: 'full_Name'},
        {text: 'อนุมัติโดย', value: 'Approve'},
        {text: 'สถานะ', value: 'Project_Status'},
        {text: '', value: 'Project_Details'}
      ],
      courseHeaders: [
        {
          text: 'รหัสหลักสูตร',
          value: 'Project_code',
        },
        {text: 'หลักสูตร', value: 'full_Name'},
        {text: 'สถานะ', value: 'IsPlanStatus'},
        {text: 'Item_Code', value: 'Item_Code'},
        {text: 'งบประมาณ', value: 'BudgetRequest'},
        {text: '', value: 'Project_Details'}
      ],
      budgetHeader: [
        {text: 'รายการ', value: 'Expense_des'},
        {text: 'จำนวนเงิน', value: 'ReqMoney'},
        {text: 'หมายเหตุ', value: 'Rm'},
        {text: '', value: 'action'}
      ],
      budgetData: [],
    }
  },
  computed: {
    ...mapGetters({
      MeData: 'Staff/getMeData',
      levelData: 'Level/getLevel',
      projectData: 'Project/getProject',
      projectForApprove: 'Project/getProjectForApprove',
      committee_Posi: 'Project/getComitteeType',
      Comittee_Data: 'Project/getComittee',
      provinces_Data: 'Project/getProvince',
      expense_Data: 'Project/getExpense',
      Competency_Data: 'Project/getCompetency',
      projectGroup: 'Project/getProjectGroup',
      textForPrint: 'Project/getTextForPrint',
      countryData: 'Project/getCountry',
      planProjectForApprove: 'Project/getProjectPlanApprove',
      planProjectForHistory: 'Project/getProjectPlanHistory',
      staffData: 'Staff/getStaff',
      positions: 'Staff/getPosition',
      ApproveMaster: 'Staff/getApproveMaster',
      depart: 'Depart/getDepart',
      courseData: 'Course/getCourse',
      Competency: 'Competency/getCompetency',
      ProjectCompetency: 'Project/getCompetency',
      ProjectExpense: 'Project/getProjectExpense',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      AllPermission: 'Permission/getAllUserPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
      PermissionAdmin: 'Permission/getPermission',
      MenuPermiss: 'Permission/getMenuPermiss',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initCourseData: 'Course/initCourseData',
      initProjectData: 'Project/initProjectData',
      initProjectDataForApprove: 'Project/initProjectDataForApprove',
      initPlanProjectDataForApprove: 'Project/initPlanProjectDataForApprove',
      initPlanProjectDataForHistory: 'Project/initPlanProjectDataForHistory',
      initComitteeData: 'Project/initComitteeData',
      initComitteeType: 'Project/initComitteeType',
      initProvincesData: 'Project/initProvincesData',
      initExpenseData: 'Project/initExpenseData',
      MangeTextForPrint: 'Project/MangeTextForPrint',
      initCountryData: 'Project/initCountryData',
      initProjectExpenseData: 'Project/initProjectExpenseData',
      initCompetencyData: 'Competency/initCompetencyData',
      initProjectCompetencyData: 'Project/initCompetencyData',
      initProjectGroupData: 'Project/initProjectGroupData',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveMaster: 'Staff/initApproveMaster',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
      getMenuPermissData: 'Permission/getMenuPermissData',
    }),
    init: function () {
      this.dialogLoading = true
      this.projectDataToTable = []
      this.projectDataToTableDump = []
      this.FiscalYearData = []
      this.initComitteeType()
      this.initCountryData()
      this.YearSel = '' + new Date().getFullYear()
      this.allMoney = 0

      for (var i = (new Date().getFullYear() - 1); i <= (new Date().getFullYear() + 1); i++) {
        this.FiscalYearData.push({
          year: i,
          yearth: i + 543
        })
      }

      // this.initProjectData({
      //   perid: this.MeData[0].perid
      // })

      this.initDepartData().then(resDep => {
        if (resDep) {
          this.initStaffData().then(resStaff => {
            if (resStaff) {
              this.initPlanProjectDataForHistory().then(resHis => {
                if (resHis) {
                  if (this.planProjectForHistory.length > 0) {
                    this.planProjectForHistory.map(Project => {
                      if (parseInt(Project.IsPlanStatus) > 0) {
                        if (this.staffData.filter(staffi => staffi.perid == Project.Create_By).length > 0) {
                          var DepCreate = this.staffData.filter(staffi => staffi.perid == Project.Create_By)
                          var DepBy = this.depart.filter(depi => depi.dep_id == Project.Dep_Code)
                          this.allMoney += parseInt(Project.BudgetRequest)
                          if (DepCreate.length > 0 && DepBy.length > 0) {
                            this.projectDataToTable.push({
                              ...Project,
                              full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                                  ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + DepBy[0].dep_name + '</span></div>' +
                                  ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + this.depart.filter(depi => depi.dep_id == DepCreate[0].dep_id)[0].dep_name + '</span></div>',
                              Owner: true
                            })
                          } else if (DepCreate.length > 0 && DepBy.length == 0) {
                            this.projectDataToTable.push({
                              ...Project,
                              full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                                  ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + this.depart.filter(depi => depi.dep_id == DepCreate[0].dep_id)[0].dep_name + '</span></div>',
                              Owner: true
                            })
                          } else if (DepCreate.length == 0 && DepBy.length > 0) {
                            this.projectDataToTable.push({
                              ...Project,
                              full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                                  ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + DepBy[0].dep_name + '</span></div>',
                              Owner: true
                            })
                          } else {
                            this.projectDataToTable.push({
                              ...Project,
                              full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name,
                              Owner: true
                            })
                          }
                        }
                      }
                    })
                    this.ChooseYearFiscal()
                    this.dialogLoading = false
                  }
                } else {
                  this.ChooseYearFiscal()
                  this.dialogLoading = false
                }
              }).catch(reason => {
                if (reason) {
                  this.ChooseYearFiscal()
                  this.dialogLoading = false
                }
              })
            }
          })
        }
      })


      if (this.courseData.length == 0) {
        this.initCourseData()
      }

      if (this.positions.length == 0) {
        this.initPositionsData()
      }

      if (this.Comittee_Data.length == 0) {
        this.initComitteeData()
      }

      if (this.provinces_Data.length == 0) {
        this.initProvincesData()
      }

      if (this.expense_Data.length == 0) {
        this.initExpenseData()
      }

      if (this.Competency_Data.length == 0) {
        this.initCompetencyData()
      }

      if (this.projectGroup.length == 0) {
        this.initProjectGroupData()
      }

    },
    ChooseYearFiscal() {
      this.allMoney = 0
      if (this.projectDataToTableDump.length == 0) {
        this.projectDataToTableDump = this.projectDataToTable
      }
      this.projectDataToTable = []
      this.projectDataToTable = this.projectDataToTableDump.filter(item => item.FiscalYear == this.YearSel)
      if (this.projectDataToTable.length > 0) {
        this.projectDataToTable.map(item => {
          this.allMoney += parseInt(item.BudgetRequest)
        })
      }
    },
    ChangeTypeProject() {
      console.log(this.TypeProject)
    },
    ShowDetailLecturer(item) {
      this.LecturerDetail = []
      this.LecturerDetail = this.WorkGroupData.filter(L_item => L_item.perid == item.Perid && L_item.type == item.Committee_code)
      this.dialogLecturerDetail = true
    },
    onProgress(evt) {
      console.log(evt)
      this.percent = 0
      this.percent = evt
    },
    hasGenerated(evt) {
      console.log(evt)
    },
    hasStartedGeneration(evt) {
      console.log(evt)
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf()
    },
    ShowTemplate() {
      // this.dialogTemplate = true
      // this.generateReport()
      let routeData = this.$router.resolve({name: 'PrintFormProject', query: {data: this.editorData}});
      window.open(routeData.href, '_blank', 'location=yes,height=800,width=800,scrollbars=yes,status=yes');
    },
    SelProjectGroup() {
      if (this.projectGroup.filter(item => item.Project_group == this.Project_group).length > 0) {
        this.projectGroupToShow = this.projectGroup.filter(item => item.Project_group == this.Project_group)[0].Project_group_des
      } else {
        this.projectGroupToShow = ''
      }
    },
    AddWorkGuest() {
      if (this.SubjectForLecturer != '' && this.dateSForLecturer != '' && this.dateEForLecturer != '' && this.timeSForLecturer != '' && this.timeEForLecturer != '') {
        this.Lecturer.push({
          perid: this.perid,
          subject: this.SubjectForLecturer,
          date_start: this.dateSForLecturer,
          date_end: this.dateEForLecturer,
          time_start: this.timeSForLecturer,
          time_end: this.timeEForLecturer
        })
        this.SubjectForLecturer = ''
        this.dateSForLecturer = ''
        this.dateEForLecturer = ''
        this.timeSForLecturer = ''
        this.timeEForLecturer = ''
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุข้อมูลให้ครบถ้วน'
        })
      }
    },
    DocumentExec() {
      this.formprint1 = this.editorData
      // axios({
      //   url: 'http://localhost:3006/exec/test', //your url
      //   method: 'GET',
      //   responseType: 'blob', // important
      // }).then((response) => {
      //   const url = window.URL.createObjectURL(new Blob([response.data]));
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute('download', 'file.docx'); //or any other extension
      //   document.body.appendChild(link);
      //   link.click();
      // });
    },
    PrintForm() {
      axios.post('http://localhost:3006/exec/docx', {
        data: {
          val1: this.formprint1, // หลักการและเหตุผล
          val2: this.formprint2, // วัตถุประสงค์
          val3: this.formprint3, // กลุ่มเป้าหมาย
          val4: this.formprint4, // วิธีการจัดอบรม
          val5: this.formprint5, // ระยะเวลาการจัดอบรม
          val6: this.formprint6, // สถานที่จัดอบรม
          val7: this.formprint7, // ผลที่คาดว่าจะได้รับ
          val8: this.formprint8, // ผู้รับผิดชอบโครงการ
          val9: this.formprint9, // ผู้รับผิดชอบโครงการ
          val10: this.formprint10, // วิทยากร
          val11: this.formprint11, // งบประมาณ
          val12: this.formprint12, // หมายเหตุ
          budget: this.budgetData,
          Lecturer: this.LecturerToShow,
          Committee: this.Committee_ToShow,
          projectGroup: this.projectGroupToShow,
          projectname: this.Project_name,
          projectcode: '01010-0220-1541'
        }
      }).then((res) => {
        console.log(res.data)
      })
      // axios({
      //   url: 'http://localhost:3006/exec/test', //your url
      //   method: 'GET',
      //   responseType: 'blob', // important
      // }).then((response) => {
      //   const url = window.URL.createObjectURL(new Blob([response.data]));
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute('download', 'file.pdf'); //or any other extension
      //   document.body.appendChild(link);
      //   link.click();
      // });
      // this.$htmlToPaper('printForm');
      // this.MangeTextForPrint({
      //     process: 'SET',
      //     message: this.editorData
      // }).then(res => {
      //     if (res) {
      //         // console.log(this.textForPrint)
      //         this.$router.push({name: 'PrintFormProject'});
      //         // window.open(routeData.href, '_blank');
      //         // console.log('------------------------------------')
      //         // console.log(this.textForPrint)
      //
      //     }
      // })
    },
    save(item) {
      const headerAxios = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      const headerAxiosPUT = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + item.Project_code, {
        Item_Code: item.Item_Code
      }, headerAxios).then(res => {
        if (res.data.status) {
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_Item_Code/', {
            Project_Code: item.Project_code,
            Item_Code: item.Item_Code,
            Create_By: this.MeData[0].perid
          }, headerAxiosPUT)
          this.snack = true
          this.snackColor = 'success'
          this.snackText = 'Data saved'
        } else {
          this.cancel()
        }
      })
    },
    cancel() {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    open() {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    close() {
      console.log('Dialog closed')
    },
    BackMenu() {
      this.Details_Cordi = false
    },
    onInput(val) {
      this.steps = parseInt(val)
    },
    backStep(n) {
      this.e1 = n
    },
    nextStep(n) {
      if (n === this.steps) {
        this.e1 = 1
      } else {
        this.e1 = n + 1
      }
    },
    DeleteFile(file_i) {
      this.File_Consider.map((item, idx) => {
        if (item.name == file_i.name) {
          this.File_Consider.splice(idx, 1)
        }
      })
    },
    ShowCompeDetail(item) {
      this.dialogDetail = true
      this.itemToShow = null
      this.itemToShow = item
    },
    showCompetency(item) {
      this.CompetencyToShow = []
      var urlConnection = ''
      urlConnection = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency_view/Project_code/' + item.Project_code
      axios.get(urlConnection).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(posi_i => {
              this.Competency.map(compe_i => {
                if (posi_i.DelvCover == compe_i.DelvNo) {
                  if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                    this.Competency.map(compe_i2 => {
                      if (compe_i.DelvCover == compe_i2.DelvNo) {
                        var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i2.DelvNo)

                        if (CheckCompetency.length == 0) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      }
                    })

                    // lv1
                    if (this.CompetencyToShow.length > 0) {
                      this.CompetencyToShow.map(ComToShow => {
                        if (ComToShow.children.length > 0) {
                          ComToShow.children.map((ComToShow_c, idx_to_Show) => {
                            CheckCompetency = false
                            if (compe_i.DelvNo == ComToShow_c.DelvNo) {
                              CheckCompetency = true
                            }
                            if (!CheckCompetency && idx_to_Show == ComToShow.children.length - 1) {
                              this.CompetencyToShow.map((data_i, idx) => {
                                if (data_i.DelvNo == compe_i.DelvCover) {
                                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes,
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  } else {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  }
                                }
                              })
                            }
                          })
                        } else {
                          this.CompetencyToShow.map((data_i, idx) => {
                            if (data_i.DelvNo == compe_i.DelvCover) {
                              if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes,
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              } else {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              }
                            }
                          })
                        }
                      })
                    }

                    //lv2
                    this.CompetencyToShow.map((data_i, idx) => {
                      data_i.children.map((child_i, c_idx) => {
                        if (child_i.DelvNo == posi_i.DelvCover) {
                          if (posi_i.DelvEng == null || posi_i.DelvEng == '') {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes,
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes + '( ' + posi_i.DelvEng + ' )',
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    })
                  } else {
                    var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i.DelvNo)

                    if (CheckCompetency.length == 0) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      }
                    }

                    this.Competency.map(compe_i2 => {
                      if (posi_i.DelvNo == compe_i2.DelvNo) {
                        this.CompetencyToShow.map((data_i, idx) => {
                          if (data_i.DelvNo == posi_i.DelvCover) {
                            if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes,
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            } else {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            }
                          }
                        })
                      }
                    })
                  }
                }
              })
            })
          } else {
            // root
            this.Competency.map(compe_i => {
              if (res.data.DelvCover == compe_i.DelvNo) {
                if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                  this.Competency.map(compe_i2 => {
                    if (compe_i.DelvCover == compe_i2.DelvNo) {
                      if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i2,
                          id: compe_i2.DelvNo,
                          name: compe_i2.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i2,
                          id: compe_i2.DelvNo,
                          name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                          DelvLevel: '0',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      }
                    }
                  })

                  // lv1
                  this.CompetencyToShow.map((data_i, idx) => {
                    if (data_i.DelvNo == compe_i.DelvCover) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '1',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '1',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      }
                    }
                  })

                  //lv2
                  this.CompetencyToShow.map((data_i, idx) => {
                    data_i.children.map((child_i, c_idx) => {
                      if (child_i.DelvNo == res.data.DelvCover) {
                        if (res.data.DelvEng == null || res.data.DelvEng == '') {
                          this.CompetencyToShow[idx].children[c_idx].children.push({
                            ...res.data,
                            id: res.data.DelvNo,
                            name: res.data.DelvDes,
                            DelvLevel: '2',
                            NeedsCredit: res.data.NeedsCredit,
                            ExpectCredit: res.data.ExpectCredit,
                            children: []
                          })
                        } else {
                          this.CompetencyToShow[idx].children[c_idx].children.push({
                            ...res.data,
                            id: res.data.DelvNo,
                            name: res.data.DelvDes + '( ' + res.data.DelvEng + ' )',
                            DelvLevel: '2',
                            NeedsCredit: res.data.NeedsCredit,
                            ExpectCredit: res.data.ExpectCredit,
                            children: []
                          })
                        }
                      }
                    })
                  })
                } else {
                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                    this.CompetencyToShow.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes,
                      DelvLevel: '0',
                      NeedsCredit: res.data.NeedsCredit,
                      ExpectCredit: res.data.ExpectCredit,
                      children: []
                    })
                  } else {
                    this.CompetencyToShow.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                      DelvLevel: '0',
                      NeedsCredit: res.data.NeedsCredit,
                      ExpectCredit: res.data.ExpectCredit,
                      children: []
                    })
                  }

                  this.Competency.map(compe_i2 => {
                    if (res.data.DelvNo == compe_i2.DelvNo) {
                      this.CompetencyToShow.map((data_i, idx) => {
                        if (data_i.DelvNo == res.data.DelvCover) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow[idx].children.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '1',
                              NeedsCredit: res.data.NeedsCredit,
                              ExpectCredit: res.data.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                              DelvLevel: '1',
                              NeedsCredit: res.data.NeedsCredit,
                              ExpectCredit: res.data.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    }
                  })
                }
              }
            })
          }
        } else {
          // Error Competency
        }
      })
    },
    ShowData: function (dataUrl) {
      window.open(
          dataUrl,
          '_blank' // <- This is what makes it open in a new window.
      );

    },
    getTrainFiles(Ref_id) {
      return new Promise(resolve => {
        var dumpArr = []
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files/Ref_id/' + Ref_id).then(res => {
          if (res.data) {
            if (res.data.length > 0) {
              dumpArr = res.data
            } else {
              dumpArr.push(res.data)
            }
          } else {
            dumpArr = []
          }
          resolve(dumpArr)
        })
      })
    },
    DelProjectOwner(item) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการลบข้อมูลเสนอแผนโครงการ " + item.Project_name + ' ใช่หรือไม่ ??',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          const headerAxios = {
            headers: {
              'Content-Type': 'application/json',
              'X-REST-METHOD': 'DELETE'
            }
          }
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + item.Project_code, '', headerAxios)
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + item.Project_code + '/?limit=1', '', {
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(res => {
            if (res.data) {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + item.Project_code, '', headerAxios)
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files/Ref_id/' + res.data.Ref_id, '', headerAxios)
            }
          })

          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_expense/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_committee/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/TemplateProject/Project_code/' + item.Project_code, '', headerAxios)

          setTimeout(() => {
            this.$swal.fire({
              timer: 1500,
              showConfirmButton: false,
              icon: 'success',
              title: 'ลบข้อมูลเสนอแผนโครงการ  ' + item.Project_name + '  สำเร็จ!!'
            }, 1500)
            this.init()
          })
        }
      })
    },
    DelProject(item) {
      this.CheckPermission().then(res => {
        if (res) {
          this.$swal.fire({
            title: 'ยืนยันการทำรายการ',
            text: "คุณต้องการลบข้อมูลเสนอแผนโครงการ " + item.Project_name + ' ใช่หรือไม่ ??',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก'
          }).then((result) => {
            if (result.value) {
              const headerAxios = {
                headers: {
                  'Content-Type': 'application/json'
                }
              }
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + item.Project_code, {
                active: '0'
              }, headerAxios).then(res => {
                if (res.data.status) {
                  setTimeout(() => {
                    this.$swal.fire({
                      timer: 1500,
                      showConfirmButton: false,
                      icon: 'success',
                      title: 'ลบข้อมูลเสนอแผนโครงการ  ' + item.Project_name + '  สำเร็จ!!'
                    }, 1500)
                    this.init()
                  })
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาดไม่สามารถลบข้อมูลได้ โปรดลองอีกครั้ง'
                  })
                }
              })
            }
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    ShowDetail(item) {
      this.dialogLoading = true
      this.e1 = '1'
      this.Expense = 0

      this.files = []
      this.Coordinator = []
      this.courseCondi = []
      this.competency_DataForSubmit = []
      this.expense_DataForSubmit = []
      this.expense_p_DataForSubmit = []
      this.FileProject = []
      this.DataCondi = []
      this.JoinPerson = []
      this.budgetData = []
      this.Lecturer = []
      this.TemplateProject = []
      this.DepQuotaData = []
      this.Project = null

      this.editorData = ''
      this.dateApprove = ''
      this.Approve_m = ''
      this.remarksApprove = ''

      this.Details_Cordi = true
      this.Project = item
      this.Project_code = item.Project_code
      this.Project_name = item.Project_name
      this.Course_code = item.Course_code
      this.course_group = item.Course_group
      this.Period_code = item.Period_code
      this.Project_type = item.Project_type
      this.Remarks = item.Remarks
      this.CalCredit = item.CalCredit
      this.CalHourse = item.CalHourse
      this.PLACE = item.PLACE
      this.Province_id = item.Province_id
      this.Country_id = item.Country_id
      this.BudgetRequest = item.BudgetRequest
      this.Location = item.Location
      this.WorkBy = item.WorkBy
      this.WorkByName = item.WorkByName
      this.DateStart = item.DateStart
      this.DateEnd = item.DateEnd
      this.DepSelect = item.Dep_Code
      this.Project_group = item.Project_group
      this.FiscalYear = parseInt(item.FiscalYear)
      this.IsPlan = item.IsPlan
      this.itemCode = item.Item_Code

      this.ChooseTypeDep = item.Approve
      this.ChooseTypRegis = item.Status_Reg
      this.ChooseTypRegis2 = item.Status_Type_Reg
      this.dateRegStart = item.DateS_Reg
      this.dateRegEnd = item.DateE_Reg
      this.ProjectQuotaCount = item.Count_Reg
      if (item.Status_Count_Reg == '0') {
        this.ChkJoinPerson = false
      } else {
        this.ChkJoinPerson = true
      }

      this.showCompetency(item)

      this.initProjectCompetencyData({
        Project_code: this.Project_code
      }).then(res => {
        if (res) {
          this.ProjectCompetency.map(ProjectCom => {
            this.selection.push(ProjectCom.DelvNo)
          })
        }
      })

      this.initProjectExpenseData({
        Project_code: this.Project_code
      }).then(res => {
        if (res) {
          this.ProjectExpense.map(ProjectEx => {
            this.expense_Data.map(expenseData => {
              if (ProjectEx.Expense_id == expenseData.Expense_id) {
                this.budgetData.push({
                  Expense_id: expenseData.Expense_id,
                  Expense_des: expenseData.Expense_des,
                  ReqMoney: ProjectEx.ReqMoney,
                  Rm: ProjectEx.Rm
                })
                this.Expense += parseFloat(ProjectEx.ReqMoney)
              }
            })

          })
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/quata_dep_reg/Project_code/' + this.Project_code).then(res => {
        if (res.data) {
          var type = ''
          if (res.data.length > 0) {
            this.projectNeed = true
            res.data.map((item_qua) => {
              type = ''
              if (item_qua.dep_type == '0') {
                type = 'หน่วยงาน/ภาควิชา'
              } else {
                type = 'กลุ่มหน่วยงาน/กลุ่มภาควิชา'
              }
              this.DepQuotaData.push({
                quotaType: item_qua.dep_type,
                type: type,
                type_id: item_qua.dep_type,
                dep_name: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_name,
                dep_id: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_id,
                dep_group_id: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_group_id,
                count: item_qua.count
              })
            })
          } else {
            this.projectNeed = true
            type = ''
            if (res.data.dep_type == '0') {
              type = 'หน่วยงาน/ภาควิชา'
            } else {
              type = 'กลุ่มหน่วยงาน/กลุ่มภาควิชา'
            }
            this.DepQuotaData.push({
              quotaType: res.data.dep_type,
              type: type,
              type_id: res.data.dep_type,
              dep_name: this.depart.filter(item => item.dep_id == res.data.dep_id)[0].dep_name,
              dep_id: this.depart.filter(item => item.dep_id == res.data.dep_id)[0].dep_id,
              dep_group_id: this.depart.filter(item => item.dep_id == res.data.dep_id)[0].dep_group_id,
              count: res.data.count
            })
          }

          if (this.DepQuotaData.length > 0) {
            this.DepQuotaData.map(item_dep_q => {
              this.ProjectQuotaDepCount += parseInt(item_dep_q.count)
            })
          }
        } else {
          this.projectNeed = false
          this.DepQuotaData = []
        }
      })


      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + item.Project_code).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.projectNeed = true
            this.WorkGroupData = res.data
          } else {
            this.projectNeed = true
            this.WorkGroupData.push(res.data)
          }

          if (this.WorkGroupData.length > 0) {
            this.WorkGroupData.map(item_w => {
              this.getTrainFiles(item_w.Ref_id).then(res => {
                item_w.files = res
              })
            })
          }
        } else {
          this.projectNeed = false
          this.WorkGroupData = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/TemplateProject/Project_code/' + item.Project_code).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.projectNeed = true
            this.TemplateProject = res.data
          } else {
            this.projectNeed = true
            this.TemplateProject.push(res.data)
          }
          if (this.TemplateProject.length > 0) {
            this.editorDataFormDB = this.TemplateProject[0].Template
            this.editorData = this.editorDataFormDB.replaceAll('&quot;', '"')
          }
        } else {
          this.projectNeed = false
          this.TemplateProject = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_record_view/Project_code/' + item.Project_code + '/Type/1/?sort=id_DESC').then(res => {
        if (res.data) {

          if (res.data.length > 0) {
            this.RecordData = res.data
          } else {
            this.RecordData.push(res.data)
          }
          this.RecordData.map(item => {
            item.files = []
          })
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/Project_code/' + item.Project_code + '/?sort=id_DESC').then(res => {
            if (res.data) {
              this.dialogLoading = false
              // var files_Project = []
              if (res.data.length > 0) {
                res.data.map(file_i => {
                  this.RecordData.map(record_i => {
                    if (record_i.Project_code == file_i.Project_code && record_i.id == file_i.project_record_id) {
                      record_i.files.push(file_i)
                    }
                  })
                })
              } else {
                this.dialogLoading = false
                this.RecordData.map(record_i => {
                  if (record_i.Project_code == res.data.Project_code && record_i.id == res.data.project_record_id) {
                    record_i.files.push(res.data)
                  }
                })
              }

            } else {
              this.dialogLoading = false
            }
          })
        } else {
          this.dialogLoading = false
          this.RecordData = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level_view/Project_code/' + item.Project_code).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.DataCondi = res.data
          } else {
            this.DataCondi.push(res.data)
          }
          if (this.DataCondi.length > 0) {
            this.DataCondi.map(item => {
              item.workAgeStart = item.WSYear
              item.workAgeEnd = item.WEYear
            })
          }
        } else {
          this.DataCondi = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_need_view/Project_code/' + item.Project_code).then(res => {
        if (res.data) {

          if (res.data.length > 0) {
            this.courseCondi = res.data
          } else {
            this.courseCondi.push(res.data)
          }
        } else {
          this.courseCondi = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_committee/Project_code/' + item.Project_code).then(res => {
        if (res.data) {

          if (res.data.length > 0) {
            this.Coordinator = res.data
          } else {
            this.Coordinator.push(res.data)
          }

          this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6')
          this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6')
          if (this.Committee_ToShow.length > 0) {
            this.Committee_ToShow.map(item => {
              item.Committee_des = this.committee_Posi.filter(commit_i => commit_i.Committee_code == item.Committee_code)[0].committee_des
            })
          }
          if (this.LecturerToShow.length > 0) {
            this.LecturerToShow.map(item => {
              item.Committee_des = this.committee_Posi.filter(commit_i => commit_i.Committee_code == item.Committee_code)[0].committee_des
            })
          }
        } else {
          this.projectNeed = false
          this.Coordinator = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/Type/0/Project_code/' + item.Project_code).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map((item) => {
              switch (item.File_type) {
                case 'image/jpg':
                case 'image/jpeg':
                case 'image/gif':
                case 'image/bmp':
                case 'image/png':
                  this.FileProject.push({
                    name: item.File_name,
                    src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                    path: item.File_path,
                    type: 'image',
                    type_Img: item.File_type
                  })
                  break
                case 'application/pdf':
                  this.FileProject.push({
                    name: item.File_name,
                    src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                    path: item.File_path,
                    type: 'pdf',
                    type_Img: item.File_type
                  })
                  break
                default:
                  break
              }
            })
          } else {
            switch (res.data.File_type) {
              case 'image/jpg':
              case 'image/jpeg':
              case 'image/gif':
              case 'image/bmp':
              case 'image/png':
                this.FileProject.push({
                  name: res.data.File_name,
                  src: ConstData.ConnectionHost + '/rest/files' + res.data.File_path,
                  path: res.data.File_path,
                  type: 'image',
                  type_Img: res.data.File_type
                })
                break
              case 'application/pdf':
                this.FileProject.push({
                  name: res.data.File_name,
                  src: ConstData.ConnectionHost + '/rest/files' + res.data.File_path,
                  path: res.data.File_path,
                  type: 'pdf',
                  type_Img: res.data.File_type
                })
                break
              default:
                break
            }
          }
        } else {
          this.FileProject = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + item.Project_code + '/active/1').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map((item) => {
              this.JoinPerson.push({
                ...item,
                full_Name: item.name + ' ' + item.sname,
                idCard: item.id_card,
              })
            })
          } else {
            this.JoinPerson.push({
              ...res.data,
              full_Name: res.data.name + ' ' + res.data.sname,
              idCard: res.data.id_card,
            })
          }
        } else {
          this.JoinPerson = []
        }
      })
    },
    Project_proposal(item) {
      this.CheckPermission().then(res => {
        if (res) {
          this.proposal = []
          this.proposal = item
          this.dialogProposal = true
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    CheckPermission() {
      return new Promise(resolve => {
        var CheckPermiss = false
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == '10001') {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
                resolve(false)
              }
            }
          })
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == '10001') {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.Permission.length - 1) {
                resolve(false)
              }
            }
          })
        }
      })
    },
    proposal_To_Db() {
      const param = {
        IsPlanStatus: '1'
      }

      const headerAxios = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + this.proposal.Project_code, param, headerAxios).then(res => {
        if (res.data.status) {
          this.dialogProposal = false
          this.initPlanProjectDataForApprove().then(res => {
            if (res) {
              if (this.planProjectForApprove.length > 0) {
                if (this.CheckAdmin) {
                  this.getPermissionDep({
                    perid: this.MeData[0].perid
                  }).then(resDep => {
                    if (resDep) {
                      this.projectDataToTable = []
                      this.planProjectForApprove.map(Project => {
                        if (this.staffData.filter(staffi => staffi.perid == Project.Create_By).length > 0) {
                          var DepCreate = this.staffData.filter(staffi => staffi.perid == Project.Create_By)
                          var DepData = this.Permission_Dep.filter(Dep => DepCreate[0].dep_id == Dep.dep_id)
                          var DepBy = this.depart.filter(depi => depi.dep_id == Project.Dep_Code)
                          if (DepData.length > 0) {
                            if (DepCreate.length > 0 && DepBy.length > 0) {
                              this.projectDataToTable.push({
                                ...Project,
                                full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                                    ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + DepBy[0].dep_name + '</span></div>' +
                                    ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + this.depart.filter(depi => depi.dep_id == DepCreate[0].dep_id)[0].dep_name + '</span></div>',
                                Owner: true
                              })
                            } else if (DepCreate.length > 0 && DepBy.length == 0) {
                              this.projectDataToTable.push({
                                ...Project,
                                full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                                    ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + this.depart.filter(depi => depi.dep_id == DepCreate[0].dep_id)[0].dep_name + '</span></div>',
                                Owner: true
                              })
                            } else if (DepCreate.length == 0 && DepBy.length > 0) {
                              this.projectDataToTable.push({
                                ...Project,
                                full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                                    ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + DepBy[0].dep_name + '</span></div>',
                                Owner: true
                              })
                            } else {
                              this.projectDataToTable.push({
                                ...Project,
                                full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name,
                                Owner: true
                              })
                            }
                          }
                        }
                      })
                      this.dialogLoading = false
                    } else {
                      this.dialogLoading = false
                    }
                  })
                } else if (this.CheckSubAdmin) {
                  this.getPermissionDepUserData({
                    perid: this.MeData[0].perid
                  }).then(resDep => {
                    if (resDep) {
                      this.projectDataToTable = []
                      this.planProjectForApprove.map(Project => {
                        if (this.staffData.filter(staffi => staffi.perid == Project.Create_By).length > 0) {
                          var DepCreate = this.staffData.filter(staffi => staffi.perid == Project.Create_By)
                          var DepData = this.Permission_Dep_User.filter(Dep => DepCreate[0].dep_id == Dep.dep_id)
                          var DepBy = this.depart.filter(depi => depi.dep_id == Project.Dep_Code)
                          if (DepData.length > 0) {
                            if (DepCreate.length > 0 && DepBy.length > 0) {
                              this.projectDataToTable.push({
                                ...Project,
                                full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                                    ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + DepBy[0].dep_name + '</span></div>' +
                                    ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + this.depart.filter(depi => depi.dep_id == DepCreate[0].dep_id)[0].dep_name + '</span></div>',
                                Owner: true
                              })
                            } else if (DepCreate.length > 0 && DepBy.length == 0) {
                              this.projectDataToTable.push({
                                ...Project,
                                full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                                    ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + this.depart.filter(depi => depi.dep_id == DepCreate[0].dep_id)[0].dep_name + '</span></div>',
                                Owner: true
                              })
                            } else if (DepCreate.length == 0 && DepBy.length > 0) {
                              this.projectDataToTable.push({
                                ...Project,
                                full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                                    ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + DepBy[0].dep_name + '</span></div>',
                                Owner: true
                              })
                            } else {
                              this.projectDataToTable.push({
                                ...Project,
                                full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name,
                                Owner: true
                              })
                            }
                          }
                        }
                      })
                      this.dialogLoading = false
                    } else {
                      this.dialogLoading = false
                    }
                  })
                }
              }
            }
          })
        }
      })
    },
    GetData(item, IsExp, FuncExp) {
      this.DataCondi = []
      this.courseCondi = []
      if (IsExp) {
        FuncExp(false)
      } else {
        FuncExp(true)

        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level_view/Project_code/' + item.Project_code).then(res => {
          if (res.data) {

            if (res.data.length > 0) {
              this.DataCondi = res.data
            } else {
              this.DataCondi.push(res.data)
            }
          } else {
            this.DataCondi = []
          }
        })

        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_need_view/Project_code/' + item.Project_code).then(res => {
          if (res.data) {

            if (res.data.length > 0) {
              this.courseCondi = res.data
            } else {
              this.courseCondi.push(res.data)
            }
          } else {
            this.courseCondi = []
          }
        })
      }
    },
    ChangeStatus: function (item) {
      if (item.Course_status == '1') {
        const param = {
          Course_status: '9'
        }

        const headerAxios = {
          headers: {
            'Content-Type': 'application/json'
          }
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_course/Course_code/' + item.Course_code, param, headerAxios).then(res => {
          if (res.data) {
            this.init()
          }
        })
      } else {
        const param = {
          Course_status: '1'
        }

        const headerAxios = {
          headers: {
            'Content-Type': 'application/json'
          }
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_course/Course_code/' + item.Course_code, param, headerAxios).then(res => {
          if (res.data.status) {
            this.init()
          }
        })
      }
    },
    FileSelect: function () {
      // var count = 0
      this.dialogLoading = true
      this.txtAlert = []
      // this.FileProject = []
      this.alert = false
      if (this.files.length > 0) {
        this.files.map((item) => {
          var Checkfile = false;
          switch (item.type) {
            case 'image/jpg':
            case 'image/jpeg':
            case 'image/gif':
            case 'image/bmp':
            case 'image/png':
              Checkfile = true;
              break
            case 'application/pdf':
              Checkfile = true;
              break
            default:
              Checkfile = false;
              break
          }

          if (Checkfile) {
            if (item.size > 2048 * 2048) {
              this.dialogLoading = false
              this.txtAlert.push({
                id: this.txtAlert.length + 1,
                Detail: 'ไฟล์ ' + item.name + ' ขนาดเกิน 4 mb*'
              })
              this.alert = true
            } else {
              const fd = new FormData()
              fd.append('file', item, item.name)
              const headerAxios = {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'WithCredentials': true,
                  "Access-Control-Allow-Origin": "*"
                  // "Accept": 'multipart/form-data'
                }
              }

              axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
                if (res.data.status) {
                  switch (item.type) {
                    case 'image/jpg':
                    case 'image/jpeg':
                    case 'image/gif':
                    case 'image/bmp':
                    case 'image/png':
                      this.File_Consider.push({
                        name: item.name,
                        src: URL.createObjectURL(item),
                        path: res.data.path,
                        type: 'image',
                        type_Img: item.type
                      })
                      this.dialogLoading = false
                      break
                    case 'application/pdf':
                      this.File_Consider.push({
                        name: item.name,
                        src: URL.createObjectURL(item),
                        path: res.data.path,
                        type: 'pdf',
                        type_Img: item.type
                      })
                      this.dialogLoading = false
                      break
                    default:
                      break
                  }

                }
              })
            }
          } else {
            this.dialogLoading = false
            this.txtAlert.push({
              id: this.txtAlert.length + 1,
              Detail: 'ไม่สนับสนุนนามสกุลไฟล์ ' + item.type.split('/')[1] + ' ( ' + item.name + ' ) '
            })
            this.alert = true
          }
        })
      }
    },
    ConsideProject() {
      if (this.Approve_m == '' && this.dateApprove == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดกรอกข้อมูล สำหรับพิจารณาโครงการให้ครบถ้วน'
        })
      } else {
        this.$swal.fire({
          title: 'ยืนยันการทำรายการ',
          text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึกข้อมูล",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก'
        }).then((result) => {
          if (result.value) {
            var param = null
            const headerAxios = {
              headers: {
                'Content-Type': 'application/json',
                'X-REST-METHOD': 'PUT'
              }
            }
            const headerAxiosUpdate = {
              headers: {
                'Content-Type': 'application/json',
              }
            }
            var status = ''

            if (this.Approve_m == '0') {
              status = '2'
            } else if (this.Approve_m == '1') {
              status = '3'
            } else {
              status = '4'
            }

            param = {
              Project_code: this.Project_code,
              Type: '1',
              Status: status,
              Remark: this.remarksApprove,
              Date_Approve: this.dateApprove,
              Create_By: this.MeData[0].perid,
              Create_Time: 'now()',
            }
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_record/', param, headerAxios).then(res => {
              if (res.data) {
                if (this.File_Consider.length > 0) {
                  axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_record_view/Project_code/' + this.Project_code + '/?sort=id_DESC&limit=1', param, headerAxios).then(res => {
                    if (res.data) {
                      const headerAxiosPUT = {
                        headers: {
                          'Content-Type': 'application/json',
                          'X-REST-METHOD': 'PUT'
                        }
                      }

                      var Count = 0

                      this.File_Consider.map((item) => {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files', {
                          Project_code: this.Project.Project_code,
                          File_name: item.name,
                          File_path: item.path,
                          File_type: item.type_Img,
                          Type: '4',
                          project_record_id: res.data.id
                        }, headerAxiosPUT).then(res => {
                          if (res.data.status) {
                            Count++
                            if (Count == this.File_Consider.length) {
                              this.File_Consider = []
                              this.files = []

                              const param = {
                                IsPlanStatus: status,
                                BudgetArrove: this.BudgetArrove,
                              }

                              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + this.Project_code, param, headerAxiosUpdate).then(res => {
                                if (res.data) {
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลสำเร็จ'
                                  })
                                  this.init()
                                  this.Details_Cordi = false
                                }
                              })
                            }
                          }
                        })
                      })
                    } else {
                      this.$swal.fire({
                        icon: 'success',
                        title: 'บันทึกข้อมูลสำเร็จ!! หมายเหตุพบข้อผิดพลาดขณะอัพโหลดไฟล์ ทำให้ไม่สามารถอัพโหลดไฟล์แนบประกอบได้'
                      })
                    }
                  })
                } else {
                  const param = {
                    IsPlanStatus: status,
                    BudgetArrove: this.BudgetArrove,
                  }
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + this.Project_code, param, headerAxiosUpdate).then(res => {
                    if (res.data) {
                      this.$swal.fire({
                        icon: 'success',
                        title: 'บันทึกข้อมูลสำเร็จ'
                      })
                      this.init()
                      this.Details_Cordi = false
                    }
                  })
                }
              }
            })
          }
        })
      }
    }
  },
  mounted() {
    this.initMeData().then(res => {
      if (res) {
        this.getMenuPermissData().then(res => {
          if (res) {
            if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '18' && item.page_status == '1').length > 0) {
              this.maintain = false
              this.initApproveMaster({
                perid: this.MeData[0].perid
              }).then(res => {
                if (res) {
                  if (this.ApproveMaster.length > 0) {
                    this.ApproveMaster.map((ApproveM, idx) => {
                      if (ApproveM.type == '2') {
                        this.CheckAdmin = true
                        this.init()
                      } else {
                        if (!this.CheckAdmin && idx == this.ApproveMaster.length - 1) {
                          this.$router.push('/')
                        }
                      }
                    })
                  }
                } else {
                  this.$router.push('/')
                }
              }).catch(reason => {
                if (reason) {
                  this.$router.push('/')
                }
              })
            } else {
              this.maintain = true
            }
          }
        }).then(err => {
          if (err) {
            this.maintain = true
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}
</style>
